module.exports = __webpack_public_path__ + "img/caret.012a5128.svg";